var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entry-controls" },
    [
      _vm.entry.isIssued
        ? [
            !_vm.entry.isExpired
              ? _c("Button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        content: "Изъять ТМЦ",
                        trigger: "hover blur",
                        placement: "top",
                      },
                      expression:
                        "{\n        content: 'Изъять ТМЦ',\n        trigger: 'hover blur',\n        placement: 'top',\n      }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: { size: "iconic", icon: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.emitAction("withdraw")
                    },
                  },
                })
              : _c("Button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        content: "Списать ТМЦ",
                        trigger: "hover blur",
                        placement: "top",
                      },
                      expression:
                        "{\n        content: 'Списать ТМЦ',\n        trigger: 'hover blur',\n        placement: 'top',\n      }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: { size: "iconic", icon: "box-arhive" },
                  on: {
                    click: function ($event) {
                      return _vm.emitAction("discard")
                    },
                  },
                }),
          ]
        : _c("Button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  content: "Выдать ТМЦ",
                  trigger: "hover blur",
                  placement: "top",
                },
                expression:
                  "{\n      content: 'Выдать ТМЦ',\n      trigger: 'hover blur',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "check" },
            on: {
              click: function ($event) {
                return _vm.emitAction("issue")
              },
            },
          }),
      _vm.entry.isIssued
        ? [
            _c("Button", {
              staticClass: "inventory-item-actions-menu",
              attrs: {
                id: "inventory-item-menu-" + _vm.randomKey,
                tabindex: "-1",
                size: "iconic",
                icon: "menu",
              },
            }),
            _c(
              "b-popover",
              {
                attrs: {
                  id: "inventory-item-menu-popover",
                  placement: "left",
                  triggers: "click blur",
                  target: "inventory-item-menu-" + _vm.randomKey,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "popover-menu" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "popover-menu__item",
                        on: {
                          click: function ($event) {
                            return _vm.emitAction("showInfo")
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "popover-menu__icon",
                          attrs: { color: "default", name: "file", size: 14 },
                        }),
                        _vm._v(" Посмотреть описание "),
                      ],
                      1
                    ),
                    _vm.entry.isIssued
                      ? [
                          !_vm.entry.isExpired
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "popover-menu__item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.emitAction("transfer")
                                      },
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "popover-menu__icon",
                                      attrs: {
                                        color: "default",
                                        name: "user-transfer",
                                        size: 14,
                                      },
                                    }),
                                    _vm._v(" Передать сотруднику "),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "popover-menu__item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.emitAction("discard")
                                      },
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "popover-menu__icon",
                                      attrs: {
                                        color: "default",
                                        name: "box-archive",
                                        size: 14,
                                      },
                                    }),
                                    _vm._v(" Списать "),
                                  ],
                                  1
                                ),
                              ]
                            : _c(
                                "div",
                                {
                                  staticClass: "popover-menu__item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.emitAction("withdraw")
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    staticClass: "popover-menu__icon",
                                    attrs: {
                                      color: "default",
                                      name: "times",
                                      size: 14,
                                    },
                                  }),
                                  _vm._v(" Изъять "),
                                ],
                                1
                              ),
                          _c(
                            "div",
                            {
                              staticClass: "popover-menu__item",
                              on: {
                                click: function ($event) {
                                  return _vm.emitAction("showHistory")
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "popover-menu__icon",
                                attrs: {
                                  color: "default",
                                  name: "clock-rotate-left",
                                  size: 14,
                                },
                              }),
                              _vm._v(" История действий "),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]
        : _c("Button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  content: "Посмотреть описание",
                  trigger: "hover blur",
                  placement: "top",
                },
                expression:
                  "{\n      content: 'Посмотреть описание',\n      trigger: 'hover blur',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "file" },
            on: {
              click: function ($event) {
                return _vm.emitAction("showInfo")
              },
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }